// document.addEventListener("DOMContentLoaded", function () {
//   gsap.registerPlugin(ScrollTrigger);

//   const sections = document.querySelectorAll(
//     ".hero-section, .outsidefoods, .main-content, .collection-tab__container, .purrfeto-new, .uniqe-test-bg-max, .tails, .faqbanners"
//   );

//   sections.forEach((section) => {
//     gsap.fromTo(
//       section,
//       {
//         opacity: 0,
//         y: 80,
//         scale: 0.95,
//       },
//       {
//         opacity: 1,
//         y: 0,
//         scale: 1,
//         duration: 1.2,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: section,
//           start: "top 80%",
//           toggleActions: "play none none none",
//         },
//       }
//     );
//   });
// });



document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  // Hero Section - fade + zoom
  gsap.from(".hero-section", {
    opacity: 0,
    scale: 0.95,
    duration: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".hero-section",
      start: "top 80%",
    },
  });

  // Outside Foods - slide in from left
  gsap.from(".outsidefoods", {
    x: -100,
    opacity: 0,
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".outsidefoods",
      start: "top 85%",
    },
  });

  // Main Content - slide in from right
  gsap.from(".main-content", {
    x: 100,
    opacity: 0,
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".main-content",
      start: "top 85%",
    },
  });

  // Collection Tab - scale in
  gsap.from(".collection-tab__container", {
    scale: 0.85,
    opacity: 0,
    duration: 1.1,
    ease: "back.out(1.7)",
    scrollTrigger: {
      trigger: ".collection-tab__container",
      start: "top 85%",
    },
  });

  // Purrfeto New - fade and rotate
  gsap.from(".purrfeto-new", {
    opacity: 0,
    rotation: 5,
    duration: 1.1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".purrfeto-new",
      start: "top 85%",
    },
  });

  // Uniqe Test BG - slide up with scale
  gsap.from(".uniqe-test-bg-max", {
    y: 100,
    scale: 0.9,
    opacity: 0,
    duration: 1.2,
    ease: "expo.out",
    scrollTrigger: {
      trigger: ".uniqe-test-bg-max",
      start: "top 85%",
    },
  });

  // Tails - fade + slide from bottom
  gsap.from(".tails", {
    y: 120,
    opacity: 0,
    duration: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".tails",
      start: "top 85%",
    },
  });

  // FAQ Banner - simple fade-in
  gsap.from(".faqbanners", {
    opacity: 0,
    duration: 1,
    ease: "power1.out",
    scrollTrigger: {
      trigger: ".faqbanners",
      start: "top 85%",
    },
  });
});
